import React, { useCallback } from 'react';

import './style.css';

import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { createPayment as createPaymentApi, verifyPayment } from '../../../api/orders';
import { CLEAR_CART } from '../../../constants/actionTypes';
import CcAvenue from './gateways/CcAvenue';
import Cod from './gateways/Cod';
import Paypal from './gateways/Paypal';
import Paytm from './gateways/Paytm';
import Razorpay from './gateways/Razorpay';

const PaymentButton = ({ currentGateway, checkoutResponse, onPaymentFailureHandler, onPaymentSuccessHandler, cartStorageKey, paymentGateways }) => {

    // const location = useLocation();
    // const checkoutResponse = location?.state?.order;

    const redirectPath = localStorage.getItem("redirect_path_after_buy_credits")

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const onPaymentSuccess = async (orderId, response) => {

        try {
            let verificationResponse = await verifyPayment({
                orderDbId: orderId,
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpaySignature: response.razorpay_signature
            });

            if (verificationResponse?.data?.payment_status === 'Failed') {
                throw new Error(verificationResponse?.data?.payment_verification_error_message);
            }

            if (onPaymentSuccessHandler) {
                onPaymentSuccessHandler(orderId);
            } else {
                if (cartStorageKey) {
                    localStorage.removeItem(cartStorageKey);
                }
                dispatch({ type: CLEAR_CART })

                alert('Plan purchased successfully.');

                if (redirectPath) {
                    navigate(redirectPath, { replace: true });
                    localStorage.removeItem("redirect_path_after_buy_credits")
                } else {
                    navigate("/employer/dashboard", { replace: true });
                }
            }

        } catch (e) {
            console.log(e);
            handleError({
                'reason': e?.message ?? 'Payment Failed. Please try again.'
            });
        }
    }

    const handleError = (error) => {
        if (onPaymentFailureHandler) {
            onPaymentFailureHandler(error);
        } else {
            alert(error.reason);
        }
    }

    const onPaymentFailed = (error) => {
        handleError(error);
    }

    const gateways = {
        paypal: Paypal,
        razorpay: Razorpay,
        paytm: Paytm,
        cod: Cod,
        ccavenue: CcAvenue,
    }

    const createPayment = useCallback(async () => {
        let data = {};
        try {
            let response = await createPaymentApi({
                "id": checkoutResponse?.order?.id,
                "payment_gateway": currentGateway?.internal_name,
                "payment_gateway_environment": currentGateway?.environment
            });
            data = response.data;
        } catch (e) {
            console.log(e);
        } finally {
        }
        return data;
    }, [checkoutResponse?.order?.id, currentGateway?.environment, currentGateway?.internal_name]);

    const getPaymentGatewayButton = (currentGateway) => {
        if (currentGateway?.internal_name) {
            const Component = gateways[currentGateway.internal_name];
            return <Component paymentGateways={paymentGateways} currentGateway={currentGateway} createPayment={createPayment} checkoutResponse={checkoutResponse} onPaymentSuccess={onPaymentSuccess} onPaymentFailed={onPaymentFailed}></Component>
        }
    }

    let button = getPaymentGatewayButton(currentGateway);
    console.log("👉 currentGateway:", currentGateway);
    console.log("👉 internal_name:", currentGateway?.internal_name);
    console.log("👉 matched component:", gateways[currentGateway?.internal_name]);
    return (
        <div id="payNowButtonContainer">
            {button}
        </div>
    )
}

export default PaymentButton;
